import {ApiOccasionsPermissions} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for occasions.
 *
 * @class
 * @extends {RulesetBase}
 */
class EventCatalogueRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;
    let onlyRead = false;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiOccasionsPermissions.readWrite.toUpperCase()
      ) {
        can("Create", "Occasion");
        can("Delete", "Occasion");
        can("Update", "Occasion");
        can("Read", "Occasion");
        onlyRead = false;
        break;
      } else if (
        permission.toUpperCase() === ApiOccasionsPermissions.read.toUpperCase()
      ) {
        onlyRead = true;
      }
    }
    if (onlyRead) {
      can("Read", "Occasion");
    }
  };
}

export default EventCatalogueRuleset;
